var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoItem108(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.71 145.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #856829;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.13,125.41v-11.75h2.74v11.75h-2.74ZM19.65,120.59v-2.3h5.74v2.3h-5.74ZM25.19,125.41v-11.75h2.72v11.75h-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.4,125.61c-.93,0-1.79-.15-2.57-.45-.78-.3-1.47-.73-2.05-1.28s-1.03-1.19-1.35-1.93-.48-1.54-.48-2.42.16-1.69.48-2.43.77-1.37,1.35-1.92c.58-.55,1.26-.97,2.04-1.28.78-.3,1.63-.45,2.56-.45s1.78.15,2.56.45c.78.3,1.46.72,2.04,1.27s1.03,1.19,1.35,1.93c.32.74.48,1.55.48,2.43s-.16,1.68-.48,2.43c-.32.74-.77,1.39-1.35,1.94-.58.55-1.26.97-2.04,1.27-.78.3-1.63.44-2.54.44ZM36.38,123.31c.53,0,1.01-.09,1.45-.28.44-.18.83-.45,1.17-.79.34-.34.6-.74.78-1.19.18-.45.28-.96.28-1.52s-.09-1.07-.28-1.52c-.18-.45-.45-.85-.78-1.19-.34-.34-.72-.6-1.17-.79-.44-.18-.93-.28-1.45-.28s-1.01.09-1.46.28c-.45.18-.84.45-1.17.79-.33.34-.59.74-.77,1.19-.18.45-.28.96-.28,1.52s.09,1.07.28,1.52c.18.45.44.85.77,1.19.33.34.72.6,1.17.79.45.18.93.28,1.46.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.13,125.41v-9.53h-3.76v-2.22h10.24v2.22h-3.76v9.53h-2.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.07,125.41v-11.75h8.88v2.18h-6.18v7.39h6.4v2.18h-9.1ZM57.57,120.51v-2.13h5.66v2.13h-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.33,125.41v-11.75h2.74v9.53h5.86v2.22h-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.47,125.41v-11.75h8.88v2.18h-6.18v7.39h6.4v2.18h-9.1ZM78.97,120.51v-2.13h5.66v2.13h-5.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.61,125.61c-.94,0-1.84-.13-2.71-.38-.87-.25-1.56-.58-2.09-.98l.92-2.05c.49.36,1.09.65,1.78.88.69.23,1.39.34,2.1.34.54,0,.97-.06,1.3-.17.33-.11.57-.26.73-.44.16-.18.23-.4.23-.65,0-.31-.12-.56-.37-.75-.25-.18-.57-.34-.98-.45-.41-.12-.85-.23-1.33-.34-.48-.11-.97-.23-1.45-.39-.49-.15-.93-.35-1.34-.6-.41-.25-.73-.58-.97-.99-.24-.41-.36-.92-.36-1.54,0-.67.18-1.28.54-1.84s.9-1,1.64-1.33c.73-.33,1.65-.5,2.76-.5.74,0,1.47.09,2.19.27.72.18,1.35.44,1.89.77l-.86,2.05c-.53-.3-1.07-.53-1.63-.68-.56-.15-1.1-.23-1.61-.23s-.97.06-1.29.18c-.32.12-.56.28-.71.48-.15.2-.23.43-.23.67,0,.31.12.57.37.76.25.19.57.34.97.45.4.11.85.21,1.34.32.49.11.98.24,1.46.39.48.16.92.36,1.33.6.4.24.73.57.98.97.25.41.38.91.38,1.52,0,.66-.18,1.27-.55,1.81-.36.55-.91.99-1.65,1.33-.74.34-1.66.5-2.77.5Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.17,
    y: 0.34,
    width: 101.37,
    height: 101.37,
    rx: 9.71,
    ry: 9.71
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.27,77.82H22.44c-.65,0-1.18-.53-1.18-1.18s.53-1.18,1.18-1.18h68.84c.65,0,1.18.53,1.18,1.18s-.53,1.18-1.18,1.18Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "72.09 76.64 69.73 76.64 69.73 26.59 43.98 26.59 43.98 76.64 41.61 76.64 41.61 24.22 72.09 24.22 72.09 76.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "86.15 76.64 83.78 76.64 83.78 39.17 70.91 39.17 70.91 36.8 86.15 36.8 86.15 76.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "29.92 76.64 27.56 76.64 27.56 36.8 42.8 36.8 42.8 39.17 29.92 39.17 29.92 76.64"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 29.64,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 29.64,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 29.64,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 35.23,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 35.23,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 35.23,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 40.82,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 40.82,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 40.82,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 46.4,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.49,
    y: 43.61,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.66,
    y: 43.61,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.49,
    y: 49.2,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.66,
    y: 49.2,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.49,
    y: 54.78,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.66,
    y: 54.78,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.49,
    y: 60.37,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.66,
    y: 60.37,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 33.49,
    y: 65.96,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.66,
    y: 65.96,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 46.4,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 46.4,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 51.99,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 51.99,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 51.99,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.92,
    y: 57.58,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 54.57,
    y: 57.58,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.22,
    y: 57.58,
    width: 4.56,
    height: 2.37
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "63.41 76.64 61.04 76.64 61.04 66.4 52.67 66.4 52.67 76.64 50.3 76.64 50.3 64.03 63.41 64.03 63.41 76.64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoItem108);
export default __webpack_public_path__ + "static/media/Icono-item-1-08.f8f2dd8e45805d2f5fea80546829b9f8.svg";
export { ForwardRef as ReactComponent };